import { useSnackbar } from 'notistack';

import { useSnackbarFromGenerated } from '../../../components/snackbars/useSnackbarFromGenerated.ts';
import {
  generateDurchgangListingErrorSnackbar,
  generateDurchgangListingSuccessSnackbar,
} from '../../../pages/ThemaDetailsPage/DurchgangListing/DurchgangListing.snackbars.tsx';
import { trpc } from '../../../trpc.ts';

export function useDurchgaengeStatusMutation({
  openLinksInNewTab = false,
}: {
  openLinksInNewTab?: boolean;
} = {}): ReturnType<typeof trpc.durchgang.updateStatusOfDurchgaenge.useMutation> {
  const { enqueueSnackbar } = useSnackbar();
  const { enqueueSnackbarFromGenerated } = useSnackbarFromGenerated();

  return trpc.durchgang.updateStatusOfDurchgaenge.useMutation({
    onError: () =>
      enqueueSnackbar(
        'Ein Fehler ist beim Statuswechsel der Durchgänge aufgetreten.' /* @todo: in content.ts verschieben? */,
        {
          variant: 'error',
          persist: true,
        },
      ),
    onSuccess: (mutateResult, input) => {
      if (mutateResult.length > 0) {
        const successDurchgaenge = mutateResult.filter(
          (result) => result.successMessages.length > 0 && result.errorMessages.length === 0,
        );
        if (successDurchgaenge.length > 0) {
          enqueueSnackbarFromGenerated(generateDurchgangListingSuccessSnackbar(successDurchgaenge));
        }

        const failedDurchgaenge = mutateResult.filter((result) => result.errorMessages.length > 0);
        if (failedDurchgaenge.length > 0) {
          enqueueSnackbarFromGenerated(
            generateDurchgangListingErrorSnackbar({
              failedDurchgaenge,
              newStatus: input.newStatus,
              openLinksInNewTab,
            }),
          );
        }
      } else {
        enqueueSnackbar('Keine Durchgänge geändert.', { variant: 'info' });
      }
    },
  });
}
